export default function filterReset() {
    return {
        certificationsFilter: [],
        departmentsFilter: [],
        distanceFilter: [],
        employmentTypeFilter: [],
        regionsFilter: [],
        zzpHoursFilter: []
    };
}
